{
  "page": {
    "title": "การแจ้งเตือน",
    "subtitle": "{{count}} การแจ้งเตือน",
    "unread_count": "ยังไม่ได้อ่าน {{count}} รายการ",
    "all_caught_up": "คุณอ่านครบทุกรายการแล้ว"
  },
  "filter": {
    "all": "ทั้งหมด",
    "unread": "ยังไม่ได้อ่าน",
    "alerts": "การแจ้งเตือนสำคัญ",
    "severity_label": "ระดับความสำคัญ",
    "severity_all": "ทุกระดับ",
    "type_label": "ประเภท",
    "type_all": "ทุกประเภท",
    "read_label": "สถานะการอ่าน",
    "read_all": "ทั้งหมด",
    "read_unread": "ยังไม่ได้อ่าน",
    "read_read": "อ่านแล้ว"
  },
  "action": {
    "mark_read": "ทำเครื่องหมายว่าอ่านแล้ว",
    "mark_all_read": "ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว",
    "view_in_report": "ดูในรายงาน",
    "view_all": "ดูทั้งหมด",
    "load_more": "โหลดเพิ่มเติม"
  },
  "severity": {
    "P1": "วิกฤต",
    "P2": "คำเตือน",
    "P3": "ข้อมูล"
  },
  "state": {
    "empty": "ไม่มีการแจ้งเตือน",
    "error": "โหลดการแจ้งเตือนล้มเหลว กรุณาลองรีเฟรชหน้า",
    "loading": "กำลังโหลดการแจ้งเตือน…",
    "unread": "ยังไม่ได้อ่าน"
  },
  "channel": {
    "telegram": "Telegram",
    "email": "อีเมล"
  },
  "tabs": {
    "label": "แท็บการแจ้งเตือน",
    "inbox": "กล่องข้อความ",
    "settings": "ตั้งค่า"
  },
  "settings": {
    "tab": "ตั้งค่า",
    "th_event": "เหตุการณ์",
    "th_severity": "ระดับ",
    "th_threshold": "ค่าเกณฑ์",
    "th_actions": "การดำเนินการ",
    "recipients": "ผู้รับ",
    "mute_window": "ช่วงเวลาปิดเสียง",
    "telegram_recipient": "ผู้รับ Telegram",
    "tg_detect_btn": "ตรวจหากลุ่ม",
    "tg_detect_detecting": "กำลังตรวจหา…",
    "tg_detect_saved": "พบกลุ่ม: {{title}} — บันทึกแล้ว",
    "tg_detect_empty": "ไม่พบกลุ่ม เพิ่มบอทเข้ากลุ่มแล้วส่ง /start@bot จากนั้นลองอีกครั้ง",
    "tg_detect_unavailable": "ยังไม่ได้ตั้งค่าบอท Telegram โปรดให้ผู้ดูแลระบบตั้งค่า NOTIF_TELEGRAM_BOT_TOKEN",
    "tg_detect_conflict": "มีเว็บฮุคทำงานอยู่ จึงตรวจหากลุ่มไม่ได้ โปรดลบเว็บฮุคแล้วลองอีกครั้ง",
    "tg_detect_error": "ตรวจหากลุ่มไม่สำเร็จ โปรดลองอีกครั้ง",
    "tg_pick_title": "พบหลายกลุ่ม — เลือกหนึ่งกลุ่ม:",
    "email_recipient": "ผู้รับอีเมล",
    "mute_from": "จาก",
    "mute_to": "ถึง",
    "preview": "ดูตัวอย่าง",
    "test_send": "ทดสอบส่ง",
    "save": "บันทึกการเปลี่ยนแปลง",
    "saved": "บันทึกการตั้งค่าแล้ว",
    "test_sent": "แสดงการแจ้งเตือนทดสอบแล้ว",
    "preview_title": "ตัวอย่างช่องทาง",
    "close": "ปิด",
    "event_sync": "การซิงค์สต็อกล้มเหลว",
    "event_oversold": "ตรวจพบการขายเกินสต็อก",
    "event_quota": "โควต้า GWP หมดแล้ว",
    "event_quota_low": "โควต้า GWP เหลือน้อย",
    "event_diff": "DIFF สินค้าคงคลังเกินค่าเกณฑ์",
    "event_order_oos": "ไม่สามารถจัดการออเดอร์ได้ (สินค้าหมดในคลัง)",
    "event_sync_stale": "การซิงค์ค้างนาน",
    "event_sync_paused": "การส่งสต๊อกถูกหยุดชั่วคราว",
    "event_buyer_cancel_requested": "ผู้ซื้อขอยกเลิกออเดอร์",
    "event_listing_discovery": "พบประกาศขายใหม่",
    "event_listing_multi_warehouse": "ประกาศขายกระจายหลายคลังสินค้า",
    "test_result_sent": "ส่งแล้ว",
    "test_result_failed": "ล้มเหลว",
    "test_result_skipped": "ข้าม",
    "telegram_recipient_placeholder": "-1001234567890",
    "email_recipient_placeholder": "ops@company.com",
    "tg_guide_title": "วิธีตั้งค่า Telegram",
    "tg_guide_steps": [
      "สร้างบอท: ส่งข้อความหา @BotFather, พิมพ์ /newbot แล้วคัดลอกโทเคน",
      "ให้ผู้ดูแลระบบตั้งค่าโทเคนบนเซิร์ฟเวอร์ (NOTIF_TELEGRAM_BOT_TOKEN) — ทำครั้งเดียว",
      "เพิ่มบอทเข้ากลุ่มของคุณ แล้วส่ง /start@bot ในกลุ่ม",
      "คลิก \"ตรวจหากลุ่ม\" ข้างช่องผู้รับ Telegram ด้านบน — ระบบจะกรอกรหัสแชทและบันทึกให้อัตโนมัติ",
      "คลิก ทดสอบส่ง เพื่อยืนยันว่าข้อความถึงกลุ่ม"
    ]
  },
  "delivery": {
    "tab": "บันทึกการส่ง",
    "kpi_sent": "ส่งทั้งหมด",
    "kpi_failed": "ล้มเหลว",
    "kpi_retrying": "กำลังลองใหม่",
    "th_event": "เหตุการณ์",
    "th_channel": "ช่องทาง",
    "th_recipient": "ผู้รับ",
    "th_time": "เวลา",
    "th_status": "สถานะ",
    "th_action": "การดำเนินการ",
    "filter_all": "ทั้งหมด",
    "filter_sent": "ส่งแล้ว",
    "filter_failed": "ล้มเหลว",
    "filter_retrying": "กำลังลองใหม่",
    "status_sent": "ส่งแล้ว",
    "status_failed": "ล้มเหลว",
    "status_retrying": "กำลังลองใหม่",
    "retry": "ลองใหม่",
    "retry_for": "ลองใหม่ {{title}}",
    "export": "ส่งออก CSV",
    "retry_ok": "อยู่ในคิวลองใหม่แล้ว",
    "exported": "ส่งออกบันทึกการส่งแล้ว",
    "empty": "ไม่มีบันทึกการส่ง",
    "error": "โหลดบันทึกการส่งล้มเหลว"
  },
  "type": {
    "sync_stale": "การซิงค์ค้างนาน",
    "sync_paused": "การส่งสต๊อกถูกหยุดชั่วคราว",
    "buyer_cancel_requested": "ผู้ซื้อขอยกเลิกออเดอร์",
    "listing_discovery": "พบประกาศขายใหม่",
    "listing_multi_warehouse": "ประกาศขายกระจายหลายคลังสินค้า"
  }
}
